export const SEARCH_MATCH_HIGHLIGHT = '#EDBADC'
